export default "__VITE_ASSET__B$ehhHUB__"